import 'src/styles/pages/_personnel.scss';
import 'src/styles/_common.scss';
import '../components/PersonnelNavBar.scss';
import ProfilePhoto from 'src/images/placeholder.jpg';

import React, { useContext, useEffect, useRef, useState } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import _ from 'lodash';
import Panel from 'src/components/common/Panel';
import Page from 'src/components/common/Page';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import useFetch from 'use-http';
import { useDispatch, useSelector } from 'react-redux';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Personnel from 'src/models/personnel/Personnel';
import { IRootState } from 'src/reducers';
import { RouteComponentProps } from 'react-router-dom';
import { push } from 'connected-react-router';
import PersonnelFormData from 'src/models/personnel/PersonnelFormData';
import { UserRoles } from 'src/models/UserRole';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import AddPersonnelDialog from '../dialogs/AddPersonnelDialog';
import PersonnelSearch from '../components/PersonnelSearch';
import PersonnelNavBar from '../components/PersonnelNavBar';
import moment from 'moment';
import DatePicker from 'react-multi-date-picker';

type IPersonnelPageProps = RouteComponentProps<{ id?: string }>;

const PersonnelPage = (props: IPersonnelPageProps) => {
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [rehireDates, setRehireDates] = useState([]);
    const [employeeStatus, setEmployeeStatus] = useState<Boolean>(false);
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<Boolean>(true); // isLoading is true if fetching personnel still
    const [personnelList, setPersonnelList] = useState<Array<Personnel>>(undefined); // The whole personnel list
    const [personnelSearchResults, setPersonnelSearchResults] = useState<Array<Personnel>>(undefined); // The personnel filtered by search (Name)
    const appContext = useContext<IAppContextState>(AppContext);

    const { get, put, response } = useFetch();
    const { register, handleSubmit, errors, getValues, setValue, reset } = useForm();
    const dispatch = useDispatch();

    const topOfPage = useRef(null);
    const bottomOfPage = useRef(null);

    // Limit access to Personnel / Employee Detail
    const userHasAccess = appContext.currentUser.role === UserRoles.HR || appContext.currentUser.role === UserRoles.Admin;
    let selectedPersonnel = useSelector((state: IRootState) => state.landman.selectedPersonnel); // Personnel selected by the user

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!rehireDates) {
            console.log('====> RehireDates = ', rehireDates);
        }
    }, [rehireDates]);

    // Set to true when the personnel is being fetched, and false afterwards
    useEffect(() => {
        console.log('====> IsLoading = ', isLoading);
    }, [isLoading]);

    // SelectedPersonnel will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (!!selectedPersonnel) {
            showPersonnelData(selectedPersonnel);
            reset(initializeData(selectedPersonnel));
            console.log('====> SelectedPersonnel = ', selectedPersonnel);
            if (selectedPersonnel?.status === 'Employee') { 
                setEmployeeStatus(true);
            } else { 
                setValue('title', ''); 
                setEmployeeStatus(false);
            }
        }
    }, [selectedPersonnel]);

    // personnelList should only change once, on initial render (it contains the full list of personnel)
    useEffect(() => {
        if (personnelList?.length) {
            console.log('====> Personnel List = ', personnelList);
            setPersonnelSearchResults(sortPersonnelByLastName(personnelList));

            if (selectedPersonnel) {
                reset(initializeData(selectedPersonnel));
                showPersonnelData(selectedPersonnel);

            } else if (props?.match?.params?.id) {
                setSelectedPersonnel(parseInt(props?.match?.params?.id, 10));
            }
        }
    }, [personnelList]);

    // personnelSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        console.log('====> Search Results = ', personnelSearchResults);

        if (personnelSearchResults?.length) {
            setIsLoading(false);
        }
    }, [personnelSearchResults]);

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('PersonnelPage onCreate()');

        getStates();
        getPersonnel();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('PersonnelPage onDestroy()');
    };

    /**
     * @returns United States (Merica) not React states
     */
    const stateDropdownOptions = () => {
        return states
            ? states?.items?.map((st: State) => {
                return { value: st.id, label: st.name };
            })
            : [];
    };

    /**
     * @returns United States (Merica) not React states
     */
    const managers = () => {
        return personnelList
            ? personnelList?.filter(p => p.userRole).map((st: Personnel) => {
                return { value: st.id, label: st.lastName };
            })
            : [];
    };

    const sortPersonnelByLastName = (list: Array<Personnel>) => {
        let sorted = list.sort((a, b) => {
            if (a.lastName < b.lastName) {
                return -1;
            }
            if (a.lastName > b.lastName) { 
                return 1;
            }
            return 0;
        });

        return sorted;
    };

    /** 
     * Called when the user focuses or types in the Search Bar
     */
    // const searchUpdate = (searchText: string) => {
    //     if (searchText?.length && personnelList?.length) {
    //         console.log('====> searchText =', searchText);
    //         searchText = searchText.toLowerCase();

    //         let fullNames = personnelList?.map(p => { return { id: p.id, name: p.firstName.toLowerCase() + ' ' + p.lastName.toLowerCase() }; });
    //         let personnelNames = fullNames?.filter(p => p.name.includes(searchText));
    //         let personnelResults = personnelList?.filter(person => personnelNames.find(result => result.id === person.id));

    //         setPersonnelSearchResults(personnelResults);
    //     } else if (personnelList?.length) {
    //         setPersonnelSearchResults(personnelList);
    //     }
    // };

    /**
     * @param e - The personnel search bar focus event
     */
    // const onSearchFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    //     setDisplayInfo(false);
    //     if (personnelList?.length && !e.target.defaultValue.length) {
    //         setPersonnelSearchResults(personnelList);
    //     }
    // };

    /**
     * Gets the list of United States (Merica) not React states
     */
    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
    const getPersonnel = async () => {
        if (userHasAccess) {
            let result = await get(`/v1.0/landmen`);

            if (response.ok) {
                setPersonnelList(result.items);
            } else {
                console.log('Unable to get the Personnel Data!!! >:c');
            }
        } else {
            setIsLoading(false);
        }
    };

    /**
     * @param data - The selected Personnel data from the list
     * @returns New data after manipulation(s) needed for the form
     */
    const initializeData = (data: Personnel) => {
        let newData: PersonnelFormData = {...data,
                        primaryEmail: data.username
                    };
        // console.log('selectedPersonel being sent to form reset', data);

        let rehiredDates: Array<Date> = [];

        data.rehireDates?.forEach(date => {
            rehiredDates.push(moment(date).format('MM/DD/YYYY') as unknown as Date);
        });
        setRehireDates(rehiredDates);

        newData.hireDate = newData.hireDate ? (moment(newData.hireDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.lastWorked = newData.lastWorked ? (moment(newData.lastWorked).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.entered = newData.entered ? (moment(newData.entered).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.term = newData.term ? (moment(newData.term).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.ptoRenewal = newData.ptoRenewal ? (moment(newData.ptoRenewal).format('YYYY-MM-DD') as unknown as Date) : null;
        return newData;
    };

    /**
     * Called when Save button is clicked
     * @param data Personnel information from the form
     */
    const onSubmit = async (data: Personnel) => {
        console.log('Personnel Page onSubmit() ;D', data);
        if (!!data) {
            updatePersonnel(finalizeData(data));
        }
    };

    /**
     * This helps finalize the data to save / send to the PersonnelController
     * @param data - The Personnel Model populated by the form
     * @returns - Updated Personnel data from the form 
     */
    const finalizeData = (data: Personnel) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: Personnel = {
            ...data,
            id: selectedPersonnel?.id,
            managerId: selectedPersonnel?.managerId,
            personDetailsId: selectedPersonnel?.personDetailsId,
            username: selectedPersonnel?.username,
            lmsNumber: selectedPersonnel?.lmsNumber,
            mailingAddressID: selectedPersonnel?.mailingAddress?.id,
            corporationAddressId: selectedPersonnel?.corporationAddress?.id,
            effectiveRate: selectedPersonnel?.effectiveRate,
            phoneNumberList: selectedPersonnel?.phoneNumberList,
        };

        // Name
        finalData.status = finalData.status ? finalData.status : null;
        finalData.firstName = finalData.firstName ? finalData.firstName : null;
        finalData.middleName = finalData.middleName ? finalData.middleName : null;
        finalData.lastName = finalData.lastName ? finalData.lastName : null;
        finalData.akaName = finalData.akaName ? finalData.akaName : null;

        // Contact Info
        finalData.primaryEmail = finalData.primaryEmail ? finalData.primaryEmail : null;
        finalData.secondaryEmail = finalData.secondaryEmail ? finalData.secondaryEmail : null;
        finalData.homePhoneNumber = finalData.homePhoneNumber ? finalData.homePhoneNumber : null;
        finalData.cellPhoneNumber = finalData.cellPhoneNumber ? finalData.cellPhoneNumber : null;

        // Corporation
        finalData.corporationName = finalData.corporationName ? finalData.corporationName : null;
        finalData.corporationAddress.state = new State();
        let corporationAdressStateId = finalData.corporationAddress?.stateId?.toString();
        data.corporationAddress.stateId = parseInt(corporationAdressStateId, 10);

        finalData.corporationAddress.state = {
            id: data.corporationAddress.stateId ? data.corporationAddress.stateId : 0,
            name: data.corporationAddress.state.name ? data.corporationAddress.state.name : '',
            abbreviation: data.corporationAddress.state.abbreviation ? data.corporationAddress.state.abbreviation : ''
        };

        finalData.corporationAddressId = finalData.corporationAddressId ? finalData.corporationAddressId : 0;
        finalData.corporationAddress.id = finalData.corporationAddressId;
        finalData.corporationAddress.addressLine1 = finalData.corporationAddress.addressLine1 ? finalData.corporationAddress.addressLine1 : null;
        finalData.corporationAddress.addressLine2 = finalData.corporationAddress.addressLine2 ? finalData.corporationAddress.addressLine2 : null;
        finalData.corporationAddress.city = finalData.corporationAddress.city ? finalData.corporationAddress.city : null;
        finalData.corporationAddress.stateId = finalData.corporationAddress.stateId ? finalData.corporationAddress.stateId : null;
        finalData.corporationAddress.zipCode = finalData.corporationAddress.zipCode ? finalData.corporationAddress.zipCode : null;

        // Mailing Address
        finalData.mailingAddress.state = new State();
        let mailingAdressStateId = finalData.mailingAddress?.stateId?.toString();
        data.mailingAddress.stateId = parseInt(mailingAdressStateId, 10);

        finalData.mailingAddress.state = {
            id: data.mailingAddress.stateId ? data.mailingAddress.stateId : 0,
            name: data.mailingAddress.state.name ? data.mailingAddress.state.name : '',
            abbreviation: data.mailingAddress.state.abbreviation ? data.mailingAddress.state.abbreviation : ''
        };

        finalData.mailingAddressID = finalData.mailingAddressID ? finalData.mailingAddressID : 0;
        finalData.mailingAddress.id = finalData.mailingAddressID;
        finalData.mailingAddress.addressLine1 = finalData.mailingAddress.addressLine1 ? finalData.mailingAddress.addressLine1 : null;
        finalData.mailingAddress.addressLine2 = finalData.mailingAddress.addressLine2 ? finalData.mailingAddress.addressLine2 : null;
        finalData.mailingAddress.city = finalData.mailingAddress.city ? finalData.mailingAddress.city : null;
        finalData.mailingAddress.stateId = finalData.mailingAddress.stateId ? finalData.mailingAddress.stateId : null;
        finalData.mailingAddress.zipCode = finalData.mailingAddress.zipCode ? finalData.mailingAddress.zipCode : null;

        // Emergency Contact
        finalData.emergencyFirstName = finalData.emergencyFirstName ? finalData.emergencyFirstName : null;
        finalData.emergencyMiddleName = finalData.emergencyMiddleName ? finalData.emergencyMiddleName : null;
        finalData.emergencyLastName = finalData.emergencyLastName ? finalData.emergencyLastName : null;
        finalData.emergencyAkaName = finalData.emergencyAkaName ? finalData.emergencyAkaName : null;
        finalData.emergencyHomePhone = finalData.emergencyHomePhone ? finalData.emergencyHomePhone : null;
        finalData.emergencyCellPhone = finalData.emergencyCellPhone ? finalData.emergencyCellPhone : null;

        // Hiring Information
        finalData.hireby = finalData.hireby ? finalData.hireby : null;
        finalData.employeeType = finalData.employeeType ? finalData.employeeType : null;
        finalData.payMethod = finalData.payMethod ? finalData.payMethod : null;

        finalData.hireDate = finalData.hireDate ? (moment(data.hireDate).format('YYYY-MM-DD') as unknown as Date) : null;
        finalData.lastWorked = finalData.lastWorked ? (moment(data.lastWorked).format('YYYY-MM-DD') as unknown as Date) : null;
        finalData.entered = finalData.entered ? (moment(data.entered).format('YYYY-MM-DD') as unknown as Date) : null;
        finalData.term = finalData.term ? (moment(data.term).format('YYYY-MM-DD') as unknown as Date) : null;

        let rehiredDates: Array<Date> = [];
        rehireDates?.forEach( date => {
            if (date?.year && date?.month.number && date?.day) {
                date = new Date(date?.year, date?.month.number - 1, date?.day);
            } else {
                date = new Date(date);
            }
            rehiredDates?.push(date);
        });
        finalData.rehireDates = rehiredDates;
        finalData.ptoRenewal = finalData.ptoRenewal ? (moment(data.ptoRenewal).format('YYYY-MM-DD') as unknown as Date) : null;

        // Current Work Location
        finalData.lastPeriod = finalData.lastPeriod ? finalData.lastPeriod : null;
        finalData.prospect1 = finalData.prospect1 ? finalData.prospect1 : null;
        finalData.prospect2 = finalData.prospect2 ? finalData.prospect2 : null;
        finalData.manager = finalData.manager ? finalData.manager : null;
        finalData.workLocation = finalData.workLocation ? finalData.workLocation : null;
        finalData.billingOffice = finalData.billingOffice ? finalData.billingOffice : null;
        finalData.omitServices = finalData.omitServices ? finalData.omitServices : false;
        finalData.omitCorp = finalData.omitCorp ? finalData.omitCorp : false;

        return finalData;
    };

    /**
     * Saves Personnel information
     * @param data Personnel information from the form
     */
    const updatePersonnel = async (data: Personnel) => {
        // console.log('====> Sending Data to Service for Update: ', data);

        let result = await put(`/v1.0/landmen/${data.id}/save-personnel`, data);

        if (response.ok) {
            window.alert('Update successful');
        } else if (result?.messageCode === '15') {
            window.alert('Update failed');
        } else {
            window.alert('Update Personnel failed');
        }
    };

    // Add the Dialog here that contains the form to Create Personnel
    const addPersonnel = () => {
        console.log('Add Personnel Clicked');
        dispatch(actions.layout.showDialog(DialogList.ADD_PERSONNEL));
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    /**
     * Sets the selected Personnel to the store if the given ID is valid and it's not already the same personnel
     * @param id - The Personnel ID
     */
    const setSelectedPersonnel = (id?: number) => {
        if (!isNaN(id) && !!id) {
            const personnel = personnelList?.find(p => p.id === id);

            if (personnel) {
                personnel?.id !== selectedPersonnel?.id ? dispatch({ type: '[landman] SET_SELECTED_PERSONNEL', payload: personnel }) : window.alert('Selected Personnel already set');
            } else {
                window.alert('Selected Personnel is Undefined');
            }
        } else {
            window.alert('id is Invalid');
        }
    };

    /**
     * Visually displays the given Personnel information to the form fields
     * @param selected - The selected Personnel
     */
    const showPersonnelData = (selected: Personnel) => {
        // setDisplayInfo(true);
        if (selected?.id && selected?.id !== selectedPersonnel?.id) {
            setSelectedPersonnel(selected.id);
            if (!selectedPersonnel && !parseInt(props?.match?.params?.id, 10)) {
                dispatch(push(`${selected.id}/home`));
            }
        } else {
            console.log('Selected Personnel already set');
        }
    };

    const checkStatus = (e: React.FormEvent<HTMLSelectElement>) => {
        if (e.currentTarget.value === 'Employee') { 
            setEmployeeStatus(true);
        } else { 
            setValue('title', ''); 
            setEmployeeStatus(false);
        }
    };

    const formatPhoneNumber = (fieldName: string) => {
        let phoneNumber = getValues(fieldName);
        phoneNumber = phoneNumber.replace(/\D/g, '');

        if (phoneNumber.length !== 10) {
            // window.alert('Phone Number must be 10 digits');
            return;
        }

        phoneNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;

        console.log(phoneNumber);

        setValue(fieldName, phoneNumber);
    };

    /**
     * Visually displays the list of Personnel to select from
     * @returns Either Loading..., No Personnel Found, or the Personnel Search Results
     */
    // const displayPersonnelSearchResults = () => {
    //     if (personnelSearchResults?.length) {
    //         return personnelSearchResults.map((person: Personnel) => {
    //             return (
    //                 <Card
    //                     className="personnel-hover"
    //                     infoBar={`${person.firstName} ${person.lastName}`}
    //                     key={`owner-${person.id}`}
    //                     badge={person.lmsNumber ? `${person.lmsNumber}` : 'N/A'}
    //                     style={{ marginTop: '.5rem', padding: '.5rem' }}
    //                     onClick={() => { 
    //                         showPersonnelData(person); 
    //                         reset(initializeData(person));
    //                     }}
    //                 />
    //             );
    //         });
    //     } else if (isLoading) {
    //         return <div className="bold-centered">Loading...</div>;
    //     } else if (!userHasAccess) {
    //         return <div className="bold-centered">For Authorized Users Only</div>;
    //     } else if (userHasAccess) {
    //         return <div className="bold-centered">No Personnel Found</div>;
    //     } else {
    //         return <div/>;
    //     }
    // };

    // BEGINNING OF PAGE:
    return (
        <div style={{ overflowY: 'hidden' }}>
            <PersonnelNavBar/>
            <PersonnelSearch showPersonnelData={showPersonnelData} setIsCollapsed={setIsCollapsed}/>
                <form id="personnelForm" onSubmit={handleSubmit(onSubmit)}>
                    <Page>
                    {selectedPersonnel && <Page.Section width={3}>
                            {/* {!displayInfo &&
                                <Panel backgroundColor="#D3D3D3">
                                    <Panel panelTitle={isLoading ? 'Loading Personnel...' : 'Personnel'}>
                                        <div style={{ marginBottom: '1rem' }}>
                                            <CardContainer className="personnel-page-personnel-list">
                                                {displayPersonnelSearchResults()}
                                            </CardContainer>
                                        </div>
                                    </Panel>
                                </Panel>} */}
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={selectedPersonnel ? `${selectedPersonnel?.firstName} ${selectedPersonnel?.lastName}` : 'Personnel Profile'} height="100%">
                                    <div className={ isCollapsed ? 'personnel-profile' : 'personnel-profile-with-search'}>
                                        <div style={{margin: '1.5rem 0'}}>
                                            <img
                                                src={ProfilePhoto}
                                                alt="Profile Photo"
                                                style={{ height: '140px', width: '140px', borderRadius: '50%' }}
                                            />
                                            <RHFSelect
                                                bodyStyle={{ marginBottom: '1rem' }}
                                                name="status"
                                                label="Status"
                                                onChange={(e) => checkStatus(e)}
                                                options={[
                                                    { value: 'Archive', label: 'Archive' },
                                                    { value: 'Bench', label: 'Bench' },
                                                    { value: 'Cannot Locate', label: 'Cannot Locate' },
                                                    { value: 'Contractor', label: 'Contractor' },
                                                    { value: 'Employee', label: 'Employee' },
                                                    { value: 'Landman Apprentice', label: 'Landman Apprentice' },
                                                    { value: 'Subcontractor', label: 'Subcontractor' },
                                                ]}
                                                register={register}
                                                errors={errors}
                                            />
                                            {employeeStatus === true && <RHFInputBox
                                                bodyStyle={{width: '50%', marginLeft: 'auto', marginRight: 'auto'}}
                                                style={{ width: '100%' }}
                                                placeholder="Title"
                                                name="title"
                                                register={register}
                                                errors={errors}
                                            />}
                                            {employeeStatus === false && <div style={{height: '3rem'}}/>}
                                            <RHFCheckbox
                                                name="isActive"
                                                label="Active"
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFCheckbox
                                                name="doNotCall"
                                                label="Do Not Call"
                                                register={register}
                                                errors={errors}
                                            />
                                            <CardContainer className="spacer" />
                                        </div>
                                    </div>
                                <CardContainer className="spacer" />
                            </Panel>
                        </Panel>
                        {/* <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <Form onSubmit={() => console.log('form submitted')}>
                                    <FormTextBox
                                        style={{ marginTop: '1rem' }}
                                        name="searchText"
                                        label="Personnel Search by Name"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => searchUpdate(e.target.value)}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => onSearchFocus(e)}
                                    />
                                </Form>
                            </Panel>
                        </Panel> */}
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="page-section-nav">
                                    <Button
                                        className="blue-hover-button"
                                        text="Add Personnel"
                                        onClick={() => addPersonnel()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ marginTop: '1rem' }}
                                        text="Save"
                                        type="submit"
                                        form="personnelForm"
                                    />
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>}
                    { selectedPersonnel && <Page.Section width={9}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={selectedPersonnel && selectedPersonnel?.lmsNumber ? `Personnel Data - ${selectedPersonnel?.lmsNumber}` : 'Personnel Data'}>
                                 <div id="formContent" style={{ maxHeight: '75vh', overflowY: 'scroll' }} className={isCollapsed ? 'large-panel' : 'large-panel-with-search'}>
                                    <div className="personnel-form">
                                        <div ref={topOfPage} style={{ display: 'flex', marginBottom: '2rem' }}>
                                            <RHFInputBox
                                                bodyStyle={{ width: '24%' }}
                                                style={{ width: '100%' }}
                                                name="firstName"
                                                label="First Name"
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFInputBox
                                                bodyStyle={{ width: '24%' }}
                                                style={{ width: '100%' }}
                                                name="middleName"
                                                label="Middle Name"
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFInputBox
                                                bodyStyle={{ width: '24%' }}
                                                style={{ width: '100%' }}
                                                name="lastName"
                                                label="Last Name"
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFInputBox
                                                bodyStyle={{ width: '24%' }}
                                                style={{ width: '100%' }}
                                                name="akaName"
                                                label="A/K/A"
                                                register={register}
                                                errors={errors}
                                            />
                                        </div>
                                        <fieldset className="legend-divider">
                                            <legend className="legend-title">Contact Info</legend>
                                        </fieldset>
                                        <div style={{ marginBottom: '2rem' }}>
                                            <div style={{ display: 'flex' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="primaryEmail"
                                                    label="Primary Email"
                                                    className="lh-half-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="secondaryEmail"
                                                    label="Secondary Email"
                                                    className="lh-half-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', marginTop: '1rem', marginBottom: '2rem' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="homePhoneNumber"
                                                    label="Home Phone"
                                                    type="text"
                                                    register={register}
                                                    errors={errors}
                                                    onBlur={() => formatPhoneNumber('homePhoneNumber')}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="cellPhoneNumber"
                                                    label="Cell Phone"
                                                    type="text"
                                                    register={register}
                                                    errors={errors}
                                                    onBlur={() => formatPhoneNumber('cellPhoneNumber')}
                                                />
                                            </div>
                                        </div>
                                        <fieldset className="legend-divider">
                                            <legend className="legend-title">Corporation</legend>
                                        </fieldset>
                                            <div style={{ display: 'flex' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationName"
                                                    label="Name"
                                                    className="lh-half-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                {/* <RHFSelect
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationRegion"
                                                    label="Region"
                                                    options={[
                                                        { value: 'Oklahoma', label: 'Oklahoma' },
                                                        { value: 'Texas', label: 'Texas' },
                                                        { value: 'East', label: 'East' },
                                                        { value: 'West', label: 'West' },
                                                    ]}
                                                    register={register}
                                                    errors={errors}
                                                /> */}
                                            </div>
                                            <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationAddress.addressLine1"
                                                    label="Corporation Address Line 1"
                                                    className="lh-half-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationAddress.addressLine2"
                                                    label="Corporation Address Line 2"
                                                    className="lh-half-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                            <div style={{ marginTop: '1rem', marginBottom: '2rem', display: 'flex' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '32.4%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationAddress.zipCode"
                                                    label="Corporation Zip Code"
                                                    className="lh-third-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationAddress.city"
                                                    label="Corporation City"
                                                    className="lh-third-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFSelect
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="corporationAddress.stateId"
                                                    label="State"
                                                    options={stateDropdownOptions()}
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                            <fieldset className="legend-divider">
                                                <legend className="legend-title">Mailing Address</legend>
                                            </fieldset>
                                            <div style={{ marginBottom: '2rem' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '49%' }}
                                                        style={{ width: '100%' }}
                                                        name="mailingAddress.addressLine1"
                                                        label="Address Line 1"
                                                        className="lh-half-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '49%' }}
                                                        style={{ width: '100%' }}
                                                        name="mailingAddress.addressLine2"
                                                        label="Address Line 2"
                                                        className="lh-half-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.4%' }}
                                                        style={{ width: '100%' }}
                                                        name="mailingAddress.zipCode"
                                                        label="Zip Code"
                                                        className="lh-third-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="mailingAddress.city"
                                                        label="City"
                                                        className="lh-third-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFSelect
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="mailingAddress.stateId"
                                                        label="State"
                                                        options={stateDropdownOptions()}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                            </div>
                                            <fieldset className="legend-divider">
                                                <legend className="legend-title">
                                                    Emergency Contact
                                                </legend>
                                            </fieldset>
                                            <div style={{ display: 'flex', marginBottom: '2rem' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '24%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyFirstName"
                                                    label="First Name"
                                                    className="lh-fourth-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '24%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyMiddleName"
                                                    label="Middle Name"
                                                    className="lh-fourth-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '24%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyLastName"
                                                    label="Last Name"
                                                    className="lh-fourth-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '24%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyAkaName"
                                                    label="A/K/A"
                                                    className="lh-fourth-width"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', marginBottom: '2rem' }}>
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyHomePhone"
                                                    label="Home Phone"
                                                    register={register}
                                                    errors={errors}
                                                    onBlur={() => formatPhoneNumber('emergencyHomePhone')}
                                                />
                                                <RHFInputBox
                                                    bodyStyle={{ width: '49%' }}
                                                    style={{ width: '100%' }}
                                                    name="emergencyCellPhone"
                                                    label="Cell Phone"
                                                    register={register}
                                                    errors={errors}
                                                    onBlur={() => formatPhoneNumber('emergencyCellPhone')}
                                                />
                                            </div>
                                            <fieldset className="legend-divider">
                                                <legend className="legend-title"> Hiring Information</legend>
                                            </fieldset>
                                            <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                {/* <RHFInputBox
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="hireby"
                                                    label="Hire By"
                                                    register={register}
                                                    errors={errors}
                                                /> */}
                                                <RHFSelect
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="hireby"
                                                    label="Hire By"
                                                    options={managers()}
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFSelect
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="employeeType"
                                                    label="Employee Type"
                                                    options={[
                                                        { value: 'Full-Time', label: 'Full-Time' },
                                                        { value: 'Part-Time', label: 'Part-Time' },
                                                        { value: 'Temporary', label: 'Temporary' },
                                                        { value: 'Seasonal', label: 'Seasonal' },
                                                    ]}
                                                    register={register}
                                                    errors={errors}
                                                />
                                                <RHFSelect
                                                    bodyStyle={{ width: '32.3%' }}
                                                    style={{ width: '100%' }}
                                                    name="payMethod"
                                                    label="T&E Entry Method"
                                                    options={[
                                                        { value: 'By Day', label: 'By Day' },
                                                        { value: 'By Hour', label: 'By Hour' },
                                                    ]}
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                            <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                <RHFInputBox
                                                    label="Hire Date"
                                                    name={`hireDate`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%' }}
                                                />
                                                <RHFInputBox
                                                    label="Last Worked"
                                                    name={`lastWorked`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%' }}
                                                />
                                                <RHFInputBox
                                                    label="Entered/Entry"
                                                    name={`entered`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%' }}
                                                />
                                            </div>
                                            <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                <RHFInputBox
                                                    label="Term"
                                                    name={`term`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%' }}
                                                />
                                                {/* <RHFInputBox
                                                    label="Rehired"
                                                    name={`rehired`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%' }}
                                                /> */}
                                                <div style={{ width: '32.3%' }}>
                                                    <label>Rehired</label>
                                                    <br/>
                                                    <DatePicker
                                                        value={rehireDates}
                                                        onChange={setRehireDates}
                                                        multiple={true}
                                                        format={'MM/DD/YYYY'}
                                                        placeholder="mm/dd/yyyy, mm/dd/yyyy"
                                                        style={{
                                                            height: '3rem', 
                                                            width: '30rem', 
                                                            borderTop: '0px', 
                                                            borderLeft: '0px', 
                                                            borderRight: '0px', 
                                                            borderBottom: '1px solid gray',
                                                            borderRadius: '0px' 
                                                        }}
                                                    />
                                                </div>
                                                <RHFInputBox
                                                    label="PTO Renewal Date"
                                                    name={`ptoRenewal`}
                                                    type="date"
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '32.3%', marginLeft: '1rem' }}
                                                />
                                            </div>
                                            <div style={{ marginTop: '1rem' }}>
                                                <div style={{ width: '32.3%' }}>
                                                    <RHFCheckbox
                                                        name="billable"
                                                        label="Billable?"
                                                        labelStyle={{ verticalAlign: 'middle' }}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row" style={{ marginTop: '3rem' }}>
                                                <Button
                                                    className="blue-hover-button"
                                                    style={{ width: '24%', marginRight: '1rem' }}
                                                    text={'Tax Info / Checking'}
                                                    onClick={() => console.log('Do something')}
                                                />
                                                <Button
                                                    className="blue-hover-button"
                                                    style={{ width: '24%', marginRight: '1rem' }}
                                                    text={'Advanced Quick Find'}
                                                    onClick={() => console.log('Do something')}
                                                />
                                                <Button
                                                    className="blue-hover-button"
                                                    style={{ width: '24%', marginRight: '1rem' }}
                                                    text={'Hiring History'}
                                                    onClick={() => console.log('Do something')}
                                                />
                                                <Button
                                                    className="blue-hover-button"
                                                    style={{ width: '24%', marginRight: '1rem' }}
                                                    text={'Confidential'}
                                                    onClick={() => console.log('Do something')}
                                                />
                                            </div>
                                            <fieldset className="legend-divider">
                                                <legend className="legend-title"> Current Work Location</legend>
                                            </fieldset>
                                            <div style={{ marginBottom: '2rem' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.4%' }}
                                                        style={{ width: '100%' }}
                                                        name="lastPeriod"
                                                        label="Last Period"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '15.7%' }}
                                                        style={{ width: '100%' }}
                                                        name="prospect1"
                                                        label="Prospect"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '15.6%' }}
                                                        style={{ width: '100%' }}
                                                        name="prospect2"
                                                        label=" "
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.4%' }}
                                                        style={{ width: '100%' }}
                                                        name="manager"
                                                        label="Manager"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '1rem', marginBottom: '2rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="workLocation"
                                                        label="Location"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFSelect
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="billingOffice"
                                                        label="Office"
                                                        options={[
                                                            { value: 'Denver', label: 'Denver' },
                                                            { value: 'Katy', label: 'Katy' },
                                                            { value: 'McMurray', label: 'McMurray' },
                                                            { value: 'OKC', label: 'Oklahoma City' },
                                                            { value: 'Renewables', label: 'Renewables' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <div style={{ width: '32.3%' }}>
                                                        <RHFCheckbox
                                                            name="omitServices"
                                                            label="Omit Services on Online Time Sheet?"
                                                            labelStyle={{ verticalAlign: 'middle' }}
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                        <RHFCheckbox
                                                            name="omitCorp"
                                                            label="Omit Corp. Name on Online Time Sheet?"
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: '1px outset', padding: '1rem', marginBottom: '2rem', marginTop: '2rem', marginRight: '.5rem', background: '#EFF4F8' }}>
                                                i: Omit Services will hide the services on the time sheet
                                                and send the direct deposit email to the second email address.
                                            </div>
                                            <div ref={bottomOfPage} />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>}
                        {!selectedPersonnel && <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                     <div>
                                        <div className="bold-centered">No Personnel Selected</div>
                                        <div style={{textAlign: 'center'}}>
                                            <Button
                                                className="blue-hover-button"
                                                text="Add Personnel"
                                                onClick={() => addPersonnel()}
                                                style={{width: '20rem', marginBottom: '1rem'}}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>}
                    </Page>
                </form>
            <AddPersonnelDialog dialogName={DialogList.ADD_PERSONNEL} personnelList={personnelList} hideDialog={hideDialog}/>
        </div>
    );
    // END OF PAGE
};

export default PersonnelPage;



// WEBPACK FOOTER //
// ./src/components/personnel/pages/PersonnelPage.tsx